import '../../styles/scss/style.scss'
import './init-foundation'
import './modules/globals'
import './modules/fancybox'
import './modules/carousel'
import './modules/animations'